<template>
  <div>
    <template v-if="toDraftAvailable && createdByCurrentUser">
      <v-btn
        :disabled="isSettingToDraft || isTypingResponse"
        :loading="isSettingToDraft"
        rounded
        :block="xs"
        class="primary-button ml-0 ml-sm-2 mt-2 mt-sm-0"
        @click="$emit('draft')"
      >
        {{ $t('previewApplicationPageStrings.labels.toDraftButton') }}
      </v-btn>
    </template>
  </div>
</template>

<script>
import { useDisplay } from 'vuetify';

export default {
  name: "CommonHandlingPanel",
  props: {
    createdByCurrentUser: Boolean,
    toDraftAvailable: Boolean,
    isSettingToDraft: Boolean,
    isTypingResponse: Boolean
  },
  setup() {
    const { xs } = useDisplay();
    return { xs };
  }
};
</script>